<template>
  <div class="food-manage">
    <div class="food-search tuolele-main-box">
      <div class="tuolele-main-search tuolele-main-search-item">
        <el-form class="fn-clear" :inline="true">

          <!-- <el-form-item label="" class="fn-left">
            <el-checkbox v-model="listQuery.tll_status" true-label="20062018214508001072" false-label="">只看已无效的例子</el-checkbox>
          </el-form-item> -->
          <el-form-item class="fn-left">
            <wq-select :selected.sync="listQuery.shop_id" placeholder="请选择校区" value-name="id" text-name="name" :data-func="$http.getShopList" />
          </el-form-item>
          <el-form-item class="fn-left">
            <wq-select :selected.sync="listQuery.status" placeholder="是否收货" value-name="id" text-name="name" :columns="statusLists" />
          </el-form-item>
          <el-form-item label="" class="fn-left">
            <el-button type="success" @click="$refs['puchsewaitreceivelisttable'].fetchTableData() ">搜索</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="tuolele-main-box">
      <wq-table ref="puchsewaitreceivelisttable" show-page sub-key="list" :other-query="listQuery" :url-func="$http.packageConfirmedForReceiptList">
        <el-table-column label="店铺" prop="shop_name" align="center" />
        <el-table-column label="包裹ID" prop="id" align="center" />
        <el-table-column label="合约ID" prop="note_id" align="center" />
        <el-table-column label="备注" prop="remark" align="center" />
        <el-table-column label="已打包物品" align="center" width="150px">
          <template slot-scope="{row}">
            <div v-for="item in row.order_list" :key="item.name+item.goods_id">{{ item.goods_name }}(数量: {{ item.num }})</div>
          </template>
        </el-table-column>
        <el-table-column label="最新物流信息" prop="receiver" align="center">
          <template slot-scope="{row}">
            <span v-if="row.express_info.orderNo"> {{ row.express_info.info[0].theLastMessage }} </span>
            <span v-if="!row.express_info.orderNo"> {{ showLastMsg(row.express_info.Traces) }} </span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="220px">
          <template slot-scope="{row}">
            <el-button v-if="row.status == 1" type="primary" size="small" @click="fnConfirm(row)">确认收货</el-button>
            <el-button type="success" size="small" @click="fnExpress(row)">修改单号</el-button>

          </template>
        </el-table-column>
      </wq-table>

    </div>

  </div>

</template>
<script>

import WqTable from '@/components/WqTable'
import WqSelect from '@/components/FormBox/WqSelect'
export default {
  name: 'TurnStudentList',
  components: {
    // Select
    WqTable,
    WqSelect
  },

  data() {
    return {
      lists: [],
      listQuery: {
        shop_id: '',
        status: 1,
        purchase_type: ''
      },
      statusLists: [{ id: 1, name: '未收货' }, { id: 2, name: '已收货' }],
      auditMessage: '',
      dialogVisible: false,
      currentAudit: {
        note_id: '',
        result: '',
        comment: ''
      },
      noteStatusLists: [],
      puchaseTypeLists: [],
      tableKey: 0
    }
  },
  created() {
  },
  methods: {

    fnConfirm(row) {
      this.$confirm(`您确定【` + row.express_code_name + `（` + row.express_no + `）】校区已经收到货了吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.confirmReceipt({ id: row.id }).then((res) => {
          if (res.code == 200) {
            this.$message({ type: 'success', message: '确认收货操作成功!' })
            this.$refs['puchsewaitreceivelisttable'].fetchTableData()
          }
        })
      })
    },
    showLastMsg(list) { // 获取快递鸟最后一条消息
      if (list) {
        var len = list.length
        return len > 0 ? list[len - 1]['AcceptStation'] : ''
      } else {
        return ''
      }
    },
    fnExpress(row) {
      this.$prompt('修改单号', '请输入快递单号', {
        showCancelButton: false,
        inputType: 'number',
        inputValue: row.express_no,
        inputErrorMessage: '请输入快递单号,必须为数字',
        inputPattern: /^\+?[1-9]\d*$/
      }).then(({ value }) => {
        this.$http.updateExpressNo({ package_id: row.id, express_no: value }).then((res) => {
          if (res.code == 200) {
            this.$message({ type: 'success', message: '快递单号更新成功!' })
            this.dialogVisible = false
            this.$refs['puchsewaitreceivelisttable'].fetchTableData()
          }
        })
      })
    },
    fnSubmitExpress(postForm) {
      this.$http.updateExpress(postForm).then((res) => {
        if (res.code == 200) {
          this.$message({ type: 'success', message: '更新成功!' })
          this.dialogVisible = false
          this.$refs['puchsewaitreceivelisttable'].fetchTableData()
        }
      })
    }
  }
}
</script>
<style lang="scss">
.el-image-viewer__wrapper .el-icon-circle-close {
  color:white
}
  .food-search {
  .tuolele-main-search-item {
    margin-bottom: 0;
    padding: 0;
    border: 0;
    .el-form--inline .el-form-item {
      display: block;
    }
    .split-time{
      margin-right: 20px;
    }
    .el-select,
    .el-input {
      width: 160px !important;
      margin-right: 20px;
    }
    span.select-date {
      margin-right: 10px;
    }
    .button-group {
      margin-left: 82px;
    }
  }
}
</style>
